"use strict";

/*
 * Ein einziger Resize-Horcher, und darin die Karten auf gleiche Hoehe bringen.
 *
 * Am 2026-08-31 von jQuery auf natives JavaScript umgeschrieben.
 *
 * Die Karten werden bei jedem Durchlauf erst auf die natuerliche Hoehe
 * zurueckgesetzt, sonst waechst die gemessene Hoehe nur noch.
 */

const onResizeCallbacks = [];

document.addEventListener("DOMContentLoaded", () => {
    let wait = false;

    window.addEventListener("resize", () => {
        if (wait) {
            return;
        }
        wait = true;

        window.setTimeout(() => {
            onResizeCallbacks.forEach((callback) => callback());
            wait = false;
        }, 200);
    });

    const cards = document.querySelectorAll(".luftwaffe-cards .luftwaffe-card-bg");
    if (cards.length === 0) {
        return;
    }

    const cardsHeightCallback = () => {
        let maxHeight = 0;
        cards.forEach((card) => {
            card.style.height = "";
            maxHeight = Math.max(maxHeight, card.offsetHeight);
        });
        cards.forEach((card) => {
            card.style.height = maxHeight + "px";
        });
    };

    cardsHeightCallback();
    onResizeCallbacks.push(cardsHeightCallback);
});
